<div class="flex h-full">
  <section
    class="bg-[url(https://www.osunstate.gov.ng/wp-content/uploads/2014/11/NYSC-members.jpg)] bg-cover bg-center bg-no-repeat basis-2/5 hidden md:block"
  >
    <div
      class="flex flex-col justify-center items-center h-[100dvh] bg-black bg-opacity-70"
    >
      <p class="font-bold tw-font-stretch-expanded text-3xl text-white text-center p-3">
        Find and post accommodations for NYSC corp members
      </p>
    </div>
  </section>

  <section class="flex flex-col justify-between basis-full md:basis-3/5">
    <div class="flex-1 flex flex-col justify-center gap-9">
      <h2 class="text-center font-medium text-xl">Login</h2>

      <form class="form gap-2" [formGroup]="loginForm">
        <mat-form-field class="full-width" appearance="fill">
          <mat-label>State code or Email</mat-label>
          <input
            title="Email or NYSC state code"
            autocomplete="username"
            matInput
            formControlName="username"
            placeholder=""
          />
          <mat-error
            *ngIf="
              loginForm.controls['username'].hasError('minlength') &&
              !loginForm.controls['username'].hasError('required')
            "
          >
            Please enter a valid state code or email
          </mat-error>
          <mat-error
            *ngIf="loginForm.controls['username'].hasError('required')"
          >
            State code or email is <strong>required</strong>
          </mat-error>
        </mat-form-field>

        <mat-form-field class="full-width" appearance="fill">
          <mat-label>Password</mat-label>
          <input
            #passwordInput
            matInput
            autocomplete="current-password"
            type="password"
            formControlName="password"
            placeholder="Minimum of 6 characters"
          />
          <button
            class="umami--click--toggle-login-password-view"
            matSuffix
            mat-icon-button
            type="button"
            aria-label="Toggle password visibility"
            (click)="togglePasswordInputIcon()"
          >
            <mat-icon>{{ passwordInputIcon }}</mat-icon>
          </button>
          <mat-hint align="start">Minimum of 6 characters</mat-hint>
          <mat-error
            *ngIf="
              loginForm.controls.password.hasError('minlength') &&
              !loginForm.controls.password.hasError('required')
            "
          >
            Please exceed 6 characters
          </mat-error>
          <mat-error
            *ngIf="loginForm.controls['password'].hasError('required')"
          >
            Password is <strong>required</strong>
          </mat-error>
        </mat-form-field>

        <app-progress-button
          type="submit"
          class="login-button"
          (click)="login()"
          buttonText="Login"
          [loading]="isLoggingIn"
          [disabled]="loginForm.invalid || isLoggingIn"
        ></app-progress-button>
      </form>
    </div>

    <div class="text-center mb-[5%]">
      Don't have an account?
      <a class="underline text-blue-700" routerLink="/signup">Sign up</a>.
    </div>
  </section>
</div>
